import { render, staticRenderFns } from "./RpdTextAreaForm.vue?vue&type=template&id=68a0f022&scoped=true"
import script from "./RpdTextAreaForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./RpdTextAreaForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RpdTextAreaForm.vue?vue&type=style&index=0&id=68a0f022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a0f022",
  null
  
)

export default component.exports